module.exports = __webpack_public_path__ + "img/25.55355e55.jpg";